var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "profile columns is-multiline mx-2" },
    [
      _c("settings-sidebar", {
        staticClass: "first column is-3 py-2 mr-md-3 mb-3 mb-md-auto",
        attrs: { "active-menu-item": "profile" }
      }),
      _vm._v(" "),
      (_vm.user.eod_technician || _vm.user.technical_interest) &&
      _vm.user.stripe_plan
        ? _c(
            "div",
            { staticClass: "second column mb-3 p-0" },
            [
              _c("cat-uxo-profile-supporter", { attrs: { user: _vm.user } }),
              _vm._v(" "),
              _c("cat-uxo-profile-change-password", {
                attrs: { user: _vm.user }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.user.eod_technician || _vm.user.technical_interest) &&
      !_vm.user.stripe_plan
        ? _c(
            "div",
            { staticClass: "second column mb-3 p-0" },
            [
              _c("cat-uxo-profile-supporter", { attrs: { user: _vm.user } }),
              _vm._v(" "),
              _c("cat-uxo-profile-change-password", {
                attrs: { user: _vm.user }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (!_vm.user.stripe_plan &&
        !_vm.user.eod_technician &&
        !_vm.user.technical_interest) ||
      (_vm.user.stripe_plan &&
        !_vm.user.eod_technician &&
        !_vm.user.technical_interest)
        ? _c(
            "div",
            { staticClass: "second column mb-3 p-0" },
            [
              _c("cat-uxo-profile-advertisement", {
                attrs: { user: _vm.user }
              }),
              _vm._v(" "),
              _c("cat-uxo-profile-change-password", {
                attrs: { user: _vm.user }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df29bada", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df29bada","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/Profile.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-df29bada","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/Profile.vue
// module chunks = 0 1